import { ContentHeaderButton } from "../../contentHeaderButton";
import { IndorImages, getIndorImageSrc } from "../../../../features";
import { deviceIsMobile } from "../../../../features/mobileTabletChecker";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { controlAreaMeasurementButton, controlCopyCoordsButton, controlGoToYandexMirrorsButton, controlHighContrastModeButton, controlMapSettingsButton, controlMapTooltipButton, controlNavigateToPanoButton, controlPanoramaUnderMapButton, controlPathNormativitiesFilterButton, controlPathNormativitiesGroupFilterButton, controlPerimeterMeasurementButton, controlRoadAccidentSegmentsFilterButton, controlRoadDiagnosticsSegmentsFilterButton, controlRosreestrSettingsButton, controlSearchLineButton, controlShowUserLocationButton, controlTableUnderMapButton } from "./widgetsFunctions";
import MapPathPositionSearch from "./specialWidgets/MapPathPositionSearch";

const mapTooltipButtonIconSrc = require('../../../../assets/images/fontAwesomeIcons/arrow-pointer-solid.svg').default
const panoramaUnderMapButtonIconSrc = require('../../../../assets/images/fontAwesomeIcons/video-solid.svg').default
const dateFilterButtonIconSrc = require('../../../../assets/images/icons/date_filter_icon.svg').default
const goToYandexMirrorsButtonIconSrc = require('../../../../assets/images/icons/yandex_mirrors_icon.svg').default
const copyCoordsButtonIconSrc = require('../../../../assets/images/icons/save_geo_icon.png')
const highContrastModeButtonIconSrc = require('../../../../assets/images/icons/black_and_white_map_icon.png')

const tableUnderMapButtonIconSrc = getIndorImageSrc(IndorImages.Table);
const perimeterMeasurementButtonIconSrc = getIndorImageSrc(IndorImages.FigurePolylinePoints);
const areaMeasurementButtonIconSrc = getIndorImageSrc(IndorImages.ModePolygonSquare);
const rosreestrSettingsButtonIconSrc = getIndorImageSrc(IndorImages.CadastreProject);
const navigateToPanoramaButtonIconSrc = getIndorImageSrc(IndorImages.VideoPanoramic);
const showUserLocationButtonIconSrc = getIndorImageSrc(IndorImages.ButtonTarget);
const mapSettingsButtonIconSrc = getIndorImageSrc(IndorImages.MapLayers);
const searchLineButtonIconSrc = getIndorImageSrc(IndorImages.MapNavigateZoom);

const MAPS_WITH_TABLE_UNDER_MAP = ["HighwayNetworkSegments", "RoadBedLayerSegments", "RoadCategorySegments", "RoadAccidents", "RoadAccidentSegments", "RoadWorkSegmentsPODD", "RoadDiagnosticsSegmentsPassport",
    "RoadWorks"
]
const MAPS_WITH_TOOLTIP = ["PathNormativitiesMeasureTypesGroup", "PathNormativitiesMeasureType", "HighwayNetworkSegments", "RoadDiagnosticsSegments",
    "RoadBedLayerSegments", "RoadCategorySegments", "RoadAccidents", "RoadAccidentSegments", "RoadWorkSegmentsPODD", "RoadDiagnosticsSegmentsPassport", "RoadWorks", "RoadWorksWithNormativities"]
const MAPS_WITH_PANORAMA_UNDER_MAP = ["PathNormativitiesMeasureType"]

export default function ContentHeaderMapWidgets({ objectTypeName, mapType }: any) {
    const navigate = useNavigate()
    const [windowIsSmall, setWindowIsSmall] = useState(false);
    const { areaMeasurementIsEnabled, copyCoordsButtonIsClicked, perimeterMeasurementIsEnabled,
        rosreestrIsEnabled, highContrastModeIsEnabled, searchLineIsShown,
        showUserLocationButtonIsClicked, tableUnderMapIsShown, panoramaUnderMapIsShown,
        goToYandexMirrorsButtonIsClicked } = useAppSelector(state => state.contentHeader)
    const mapTooltipIsEnabled = useAppSelector(state => state.mapTooltip.mapTooltipIsEnabled)
    const sideBarIsShown = useAppSelector(state => state.sidebar.sidebarIsShown)

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        if (mapType === 'pathNormativitiesMeasureTypesGroup') {
            setWindowIsSmall(contentHeaderWidth < 1381)
        } else if (mapType === 'pathNormativitiesMeasureType') {
            setWindowIsSmall(contentHeaderWidth < 400)
        } else if (mapType === 'pathNormativitiesMeasureTypeTotal') {
            setWindowIsSmall(contentHeaderWidth < 720)
        } else if (mapType === 'roadDiagnosticsSegments') {
            setWindowIsSmall(contentHeaderWidth < 440)
        } else {
            setWindowIsSmall(contentHeaderWidth < 720)
        }
    }, [sideBarIsShown, navigate])

    const tableUnderMapControlButtonIsVisible = MAPS_WITH_TABLE_UNDER_MAP.includes(objectTypeName)
    const mapTooltipControlButtonIsVisible = !deviceIsMobile() && MAPS_WITH_TOOLTIP.includes(objectTypeName)
    const panoramaUnderMapControlButtonIsVisible = MAPS_WITH_PANORAMA_UNDER_MAP.includes(objectTypeName)
    const roadAccidentSegmentsFilterButtonIsVisible = windowIsSmall && mapType === 'roadAccidentSegments'
    const roadDiagnosticsSegmentsFilterButtonIsVisible = windowIsSmall && mapType === 'roadDiagnosticsSegments'
    const pathNormativitiesGroupFilterButtonIsVisible = windowIsSmall && mapType === 'pathNormativitiesMeasureTypesGroup'
    const pathNormativitiesFilterButtonIsVisible = windowIsSmall && (mapType === 'pathNormativitiesMeasureType' || mapType === 'pathNormativitiesMeasureTypeTotal')
    const searchLineButtonIsVisible = (mapType !== "path" && mapType !== "object")
    const pathPositionSearchButtonIsVisible = mapType === "path"

    const widgetsConfigArray = [
        {
            visible: tableUnderMapControlButtonIsVisible,
            name: "Таблица по информации на карте",
            active: tableUnderMapIsShown,
            imageSrc: tableUnderMapButtonIconSrc,
            onClick: controlTableUnderMapButton
        },
        {
            name: "Измерение расстояния",
            active: perimeterMeasurementIsEnabled,
            imageSrc: perimeterMeasurementButtonIconSrc,
            onClick: controlPerimeterMeasurementButton
        },
        {
            name: "Измерение площади",
            active: areaMeasurementIsEnabled,
            imageSrc: areaMeasurementButtonIconSrc,
            onClick: controlAreaMeasurementButton
        },
        {
            name: "Кадастровые данные от Росреестр",
            active: rosreestrIsEnabled,
            imageSrc: rosreestrSettingsButtonIconSrc,
            onClick: controlRosreestrSettingsButton
        },
        {
            name: "На панораму",
            imageSrc: navigateToPanoramaButtonIconSrc,
            onClick: controlNavigateToPanoButton
        },
        {
            active: showUserLocationButtonIsClicked,
            name: "Текущая позиция",
            imageSrc: showUserLocationButtonIconSrc,
            onClick: controlShowUserLocationButton
        },
        {
            name: "Настройки карты",
            imageSrc: mapSettingsButtonIconSrc,
            onClick: () => controlMapSettingsButton(navigate)
        },
        {
            active: copyCoordsButtonIsClicked,
            name: "Скопировать координаты в буфер обмена",
            imageSrc: copyCoordsButtonIconSrc,
            onClick: controlCopyCoordsButton
        },
        {
            active: goToYandexMirrorsButtonIsClicked,
            name: "Открыть позицию на карте в Яндекс Зеркала",
            imageSrc: goToYandexMirrorsButtonIconSrc,
            onClick: controlGoToYandexMirrorsButton
        },
        {
            active: highContrastModeIsEnabled,
            name: "Режим высокой контрастности",
            imageSrc: highContrastModeButtonIconSrc,
            onClick: controlHighContrastModeButton
        },
        {
            visible: searchLineButtonIsVisible,
            active: searchLineIsShown,
            name: "Поиск",
            imageSrc: searchLineButtonIconSrc,
            onClick: controlSearchLineButton
        },
        {
            visible: mapTooltipControlButtonIsVisible,
            active: mapTooltipIsEnabled,
            name: "Подсказка",
            imageSrc: mapTooltipButtonIconSrc,
            onClick: controlMapTooltipButton
        },
        {
            visible: panoramaUnderMapControlButtonIsVisible,
            active: panoramaUnderMapIsShown,
            name: "Кадры видео съёмки",
            imageSrc: panoramaUnderMapButtonIconSrc,
            onClick: controlPanoramaUnderMapButton
        },
        {
            visible: pathNormativitiesFilterButtonIsVisible,
            name: "Настройки фильтров ненормативных участков",
            imageSrc: dateFilterButtonIconSrc,
            onClick: () => controlPathNormativitiesFilterButton(navigate)
        },
        {
            visible: pathNormativitiesGroupFilterButtonIsVisible,
            name: "Настройки фильтров ненормативных участков",
            imageSrc: dateFilterButtonIconSrc,
            onClick: () => controlPathNormativitiesGroupFilterButton(navigate)
        },
        {
            visible: roadDiagnosticsSegmentsFilterButtonIsVisible,
            name: "Настройки фильтров участков диагностики",
            imageSrc: dateFilterButtonIconSrc,
            onClick: () => controlRoadDiagnosticsSegmentsFilterButton(navigate)
        },
        {
            visible: roadAccidentSegmentsFilterButtonIsVisible,
            name: "Настройки фильтров участков концентрации ДТП",
            imageSrc: dateFilterButtonIconSrc,
            onClick: () => controlRoadAccidentSegmentsFilterButton(navigate)
        }
    ]

    return (
        <>
            {pathPositionSearchButtonIsVisible &&
                <MapPathPositionSearch />
            }
            {widgetsConfigArray.map((contentHeaderMapWidget: any) => {
                const { visible, name, active, imageSrc, onClick } = contentHeaderMapWidget ?? {}
                const buttonIsVisible = ('visible' in contentHeaderMapWidget && visible) || !('visible' in contentHeaderMapWidget)
                if (buttonIsVisible) {
                    return (
                        <ContentHeaderButton
                            active={active}
                            imageSrc={imageSrc}
                            name={name}
                            onClick={onClick}
                        />
                    )
                }
            })}
        </>
    )
}